import { createContext } from 'react';

export type TProfileContextValue = {
  permissions: string[];
};
export const ProfileContext = createContext<TProfileContextValue>({
  permissions: [],
});
